// TODO: date is not Migrated
<template>
  <div
    class="flight-box-title-flight flex flex-wrap -mx-4"
    :class="{ 'pt-4': !flightsCollapsed }"
  >
    <div
      class="lg:w-7/12 md:w-9/12 px-4 w-8/12"
      :class="{ 'w-12/12 lg:w-12/12': flightsCollapsed }"
    >
      <div class="flex items-center">
        <strong>
          {{ localeDate(flight.departure.at, 'HH:mm') }}
        </strong>
        <span
          v-if="flightsCollapsed"
          class="ml-2"
        >{{ flight.departure.iataCode }}</span>
        <slot name="flight-stops" />
        <div
          v-if="flightsCollapsed"
          class="ml-4"
        >
          <strong>
            {{ localeDate((arrival || flight.arrival).at, 'HH:mm') }}
          </strong>
          <span class="ml-2">
            {{ (arrival || flight.arrival).iataCode }}
          </span>
        </div>
      </div>
      <div v-if="!flightsCollapsed">
        {{ airportName(flight.departure.iataCode) }}
      </div>
      <div
        v-if="!flightsCollapsed"
        class="flight-box-title"
      >
        {{ localeDate(flight.departure.at) }}
      </div>
    </div>
    <div
      v-if="!flightsCollapsed"
      class="lg:w-5/12 md:w-3/12 px-4 w-4/12"
    >
      <div class="flex justify-between items-center">
        <div>
          <strong>
            {{ localeDate((arrival || flight.arrival).at, 'HH:mm') }}
          </strong>
          <div>
            {{ airportName((arrival || flight.arrival).iataCode) }}
          </div>
          <div class="flight-box-title">
            {{ localeDate((arrival || flight.arrival).at) }}
          </div>
        </div>
      </div>
    </div>
    <div class="w-12/12 mt-1 px-4">
      <slot name="leg-info" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia'
import carrierInfo from '@packages/air/airlines.js'

export default defineNuxtComponent({
  setup () {
    const { localeDate } = useDate()

    return {
      localeDate,
    }
  },

  name: 'CharterFlightLeg',

  props: {
    flight: {
      type: Object,
      required: true,
    },

    duration: {
      type: String,
      default: null,
    },

    stops: {
      type: Number,
      default: 0,
    },

    type: {
      type: String,
      default: null,
    },

    primary: {
      type: Boolean,
      default: false,
    },

    expanded: {
      type: Boolean,
      default: false,
    },

    arrival: {
      type: Object,
      default: null,
    },

    flightsCollapsed: {
      type: Boolean,
      default: false,
    },

    showLuggage: {
      type: Boolean,
      default: false,
    },

    luggage: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState(useRootStore, ['charterAirportNames']),
  },

  methods: {
    airportName (iata) {
      const airport = this.charterAirportNames[iata]
      return `${airport?.city || ''} (${iata})`
    },

    airlineName (code) {
      return carrierInfo[code]?.name || code
    },
  },
})
</script>

<style lang="scss" scoped>
@import "@layers/web/assets/scss/modules/charter/_flight-box";
</style>
